module.exports = __webpack_public_path__ + "media/gallery/photo02-27d8985e.webp";